import { z } from 'zod';
import { PrismaEnums } from '@airreading/schema/browser';

export const backgroundCheckStatusSchema = z.enum([
  'checkr_passed',
  'ebr_fingerprint_passed',
  'ebr_fingerprint_quality_reject',
  'california_fingerprint_passed',
  'florida_fingerprint_passed',
  'florida_foundations_course_completed',
  'uva_cleared',
  'louisiana_can',
]);

export const techCheckTypeSchema = z.enum(['zoomTechCheck', 'googleMeetTechCheck']);

export const teachingPreferenceSchema = z.nativeEnum(PrismaEnums.TeachingPreference);
export type TeachingPreference = z.infer<typeof teachingPreferenceSchema>;
export const TeachingPreference = teachingPreferenceSchema.enum;
export const TeachingPreferenceLabelMap: Record<TeachingPreference, string> = {
  [TeachingPreference.regular_schedule]: 'Regular schedule',
  [TeachingPreference.substitute_teaching]: 'Substitute teaching',
};
